import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { proofPoints } from "../data/site";

/**
 * The three figures under the hero headline.
 *
 * Deliberately not cards. The hero already carries a portrait, a headline, a
 * paragraph and three buttons; giving these borders and shadows too would make
 * the first screen a pile of boxes. Hairline rules between the columns are
 * enough to read them as a set.
 */
const ProofStrip = () => (
  <Box
    component="dl"
    sx={(theme) => ({
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: { xs: 1.5, sm: 3 },
      m: 0,
      maxWidth: 560,
      width: "100%",
      "& > div + div": {
        borderLeft: theme.tokens.hairline,
        pl: { xs: 1.5, sm: 3 },
      },
    })}
  >
    {proofPoints.map(({ value, label }) => (
      <Box key={label}>
        <Typography
          component="dt"
          sx={(theme) => ({
            fontSize: { xs: "1.5rem", sm: "1.75rem" },
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: "-0.03em",
            color: theme.palette.text.primary,
          })}
        >
          {value}
        </Typography>
        <Typography
          component="dd"
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", m: 0, mt: 0.75, textWrap: "balance" }}
        >
          {label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default ProofStrip;
